<div class="tooltip">
  <button class="tooltip-trigger"><fa-icon icon="question-circle"></fa-icon></button>
  <div [class]="'tooltip-container ' + tooltipPosition">
    <div *ngIf="title" class="tooltip-header">
      {{ title }}
    </div>
    <div *ngIf="content" class="tooltip-content">
      <p class="caption" [innerHTML]="content"></p>
      <p *ngIf="emphasis" class="caption">
        <em>{{ emphasis }}</em>
      </p>
    </div>
  </div>
</div>
